import OutsideClickHandler from 'react-outside-click-handler';
import { ReactNode, useState } from 'react';
import styles from './Dropdown.module.css';

type DropdownProps = {
  title: string;
  children: ReactNode
}

function Dropdown(props: DropdownProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(prevState => !prevState);
  };

  const outsideClickHandler = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <OutsideClickHandler onOutsideClick={outsideClickHandler} display='inline-block'>
      <div
        role='button'
        tabIndex={0}
        className={styles.container}
        onClick={toggle}
        onKeyDown={toggle}
      >
        <span className={styles.text}>{props.title}</span>
        <div className={styles.arrow}>
          <div className={isOpen ? styles.arrowUp : styles.arrowDown} />
        </div>
      </div>
      {isOpen && (
        <div className={styles.dropdownContainer}>
          {props.children}
        </div>
      )}
    </OutsideClickHandler>
  );
}

export default Dropdown;
